import { _ as __rest } from '../tslib.es6-17e0406b.js';
import { jsx } from 'react/jsx-runtime';
import { Grid, Typography } from '@mui/material';

const NotFoundList = (_a) => {
    var { message } = _a, rest = __rest(_a, ["message"]);
    return (jsx(Grid, Object.assign({ container: true, justifyContent: "center", alignItems: "center" }, rest, { children: jsx(Grid, Object.assign({ item: true }, { children: jsx(Typography, Object.assign({ variant: "h5", color: "textPrimary" }, { children: message })) })) })));
};

export { NotFoundList };
